const optsEstadoCivil = [
  { value: 0, text: 'Soltero/a' },
  { value: 1, text: 'Casado/a' },
  { value: 2, text: 'Divorciado/a' },
  { value: 3, text: 'Separado/a' },
  { value: 4, text: 'Viudo/a' },
  { value: 5, text: 'Union Hecho' }
];


export const dataPersonas = {
  optsEstadoCivil,
}